import Vue from 'vue'

const actions = {
  adminFetchUserTeamMembers (context, { userCompanyGroupId }) {
    return Vue.api.get(`/admin/user-team-members/${userCompanyGroupId}`)
  },

  adminFetchPotentialUserTeamMembers (context, { userCompanyGroupId, ...params } = {}) {
    return Vue.api.get(`/admin/user-team-members/${userCompanyGroupId}/load-potential-team-members`, { params })
  },

  adminUpdateUserTeamMembers (context, { userCompanyGroupId, addTeamMembers, deleteTeamMembers }) {
    const data = { addTeamMembers, deleteTeamMembers }
    return Vue.api.post(`/admin/user-team-members/${userCompanyGroupId}`, { data })
  },

  adminFetchUserTeamMemberRoles (context, params) {
    return Vue.api.get('/admin/user-team-members/load-user-roles', { params })
  }
}

export default actions
